if (!customElements.get('pace-collection-slider')) {
  customElements.define('pace-collection-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.pace-category-grid');
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      if (!this.track || !this.previous || !this.next) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
    }

    move(direction) {
      const card = this.track.querySelector('.pace-category');
      if (!card) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap) || 0;
      const rtl = style.direction === 'rtl' ? -1 : 1;
      this.track.scrollBy({
        left: direction * rtl * (card.getBoundingClientRect().width + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    update() {
      const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.previous.hidden = !overflowing;
      this.next.hidden = !overflowing;
      this.previous.disabled = position < 2;
      this.next.disabled = position >= maximum - 2;
      const image = this.track.querySelector('.pace-category__image');
      if (image) this.style.setProperty('--pace-collection-image-height', image.getBoundingClientRect().height + 'px');
    }
  });
}
